import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton, Typography } from '@mui/material';
import { FileText, X } from 'lucide-react';
import { MessageAttachment } from '../../../types';

interface PendingAttachmentsProps {
  attachments: MessageAttachment[];
  onRemove: (attachmentId: string) => void;
}

export const PendingAttachments: React.FC<PendingAttachmentsProps> = ({
  attachments,
  onRemove,
}) => {
  return (
    <List>
      {attachments.map((attachment) => (
        <ListItem
          key={attachment.id}
          sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            mb: 1,
          }}
        >
          <ListItemIcon>
            <FileText size={18} />
          </ListItemIcon>
          <ListItemText
            primary={attachment.name}
            secondary={
              attachment.caseId && attachment.stageId ? (
                <Typography variant="caption" color="text.secondary">
                  Linked to case stage
                </Typography>
              ) : null
            }
            primaryTypographyProps={{
              variant: 'body2',
            }}
          />
          <ListItemSecondaryAction>
            <IconButton
              edge="end"
              size="small"
              onClick={() => onRemove(attachment.id)}
            >
              <X size={16} />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};